import React from 'react';
import ComingSoon from '../ComingSoon';

const XCoder = () => {
    return (
        <ComingSoon 
            title="🔐 X-Coder"
            description="Encoder & Decoder für verschiedene Formate"
            icon="🔄"
            features={[
                "Base64 Encode/Decode",
                "URL Encode/Decode",
                "HTML Encode/Decode",
                "Hex Encode/Decode",
                "Unicode Converter",
                "Batch-Konvertierung"
            ]}
        />
    );
};

export default XCoder;